import { MRT_ColumnDef } from 'mantine-react-table'
import { memo } from 'react'
import { useNavigate } from 'react-router-dom'
import CountryPageList from 'src/containers/Country/CountryPageList'
import { buildLocationUsersPagePath } from 'src/utils/userLocationFilter'

function UserCountryPage() {
	const navigate = useNavigate()

	const handleCountryClick = (countryName: string) => {
		if (countryName) {
			navigate(buildLocationUsersPagePath('country', countryName))
		}
	}

	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'country',
			header: 'Country',
			Cell: ({ cell }) => {
				const countryName = cell.getValue<string>()
				return countryName ? (
					<span
						onClick={() => handleCountryClick(countryName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{countryName}
					</span>
				) : (
					<span>{countryName}</span>
				)
			},
		},
		{
			accessorKey: 'amount',
			header: 'Amount of user',
		},
		{
			accessorKey: 'country1',
			header: 'Country',
			Cell: ({ cell }) => {
				const countryName = cell.getValue<string>()
				return countryName ? (
					<span
						onClick={() => handleCountryClick(countryName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{countryName}
					</span>
				) : (
					<span>{countryName}</span>
				)
			},
		},
		{
			accessorKey: 'amount1',
			header: 'Amount of user',
		},
		{
			accessorKey: 'country2',
			header: 'Country',
			Cell: ({ cell }) => {
				const countryName = cell.getValue<string>()
				return countryName ? (
					<span
						onClick={() => handleCountryClick(countryName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{countryName}
					</span>
				) : (
					<span>{countryName}</span>
				)
			},
		},
		{
			accessorKey: 'amount2',
			header: 'Amount of user',
		},
	]
	const fields = [
		{
			value: 'country',
			label: 'Country',
		},
	]
	return <CountryPageList columns={columns} fields={fields} />
}

export default memo(UserCountryPage)
